import React, {Component} from 'react';
import axios from 'axios';
import $ from 'jquery';
import Header from "./Header";
import SideBar from "./SideBar";
import Chart from 'chart.js/auto';
import Data from "./Data";
import {CircularProgress} from "@material-ui/core";

class Price extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fields : {
                price : "300000",
                tax : "9",
                taxactive : false
            },
            errors : {

            }
        }
    }

    componentDidMount() {
        $('#progressTop').addClass('invisible');
        $('#no_item').addClass('invisible');

    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        fields[target.name] = target.value;
        this.setState({fields});
    }

    render() {
        $('#progressTop').addClass('invisible');

        const {price , tax, taxactive} = this.state.fields;
        const {errors} = this.state;

        return (
            <div>
            <Header />
            <div className="container-fluid">
            <div className="row">
            <SideBar li="pricepanel" />
            <div className="col-12 col-md-10 bg-light mr-auto p-4" id="main">
                <form className="login-form mx-auto">
                    <div className="form-group text-right">
                        <label>قیمت به تومان</label>
                        <input
                            type="number"
                            className={["form-control", errors['name'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="price"
                            value={price}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا نام هنرجو را وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['price'] ? 'block':'none'}}>{errors['price']}</span>
                    </div>
                    <div className="form-group text-right">
                        <label>درصد مالیات</label>
                        <input
                            type="number"
                            className={["form-control", errors['family'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="tax"
                            value={tax}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا نام خانوادگی هنرجو را وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['tax'] ? 'block':'none'}}>{errors['tax']}</span>
                    </div>
                    <div className="form-check text-right">
                        <input
                            type="checkbox"
                            className={["form-check_input", errors['phone'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="taxactive"
                            id="taxactive"
                            value={taxactive}
                            checked={taxactive}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا شماره تلفن هنرجو را وارد کنید"/>
                        <label className="form-check-label" for="taxactive">مالیات</label>
                        <span className="invalid-feedback rtl" style={{display : errors['taxactive'] ? 'block':'none'}}>{errors['taxactive']}</span>

                    </div>

                    <button id="save_price"
                            className="btn btn-primary w-100">ذخیره
                    </button>


                </form>

            </div>
            </div>
            </div>
            </div>
        );
    }
}

export default Price;
